import * as tslib_1 from "tslib";
import { Item } from './item';
import { Value } from './value';
var Bool = (function (_super) {
    tslib_1.__extends(Bool, _super);
    function Bool(value) {
        var _this = _super.call(this) || this;
        _this._value = value;
        return _this;
    }
    Object.defineProperty(Bool.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    Bool.prototype.or = function (that) {
        return this;
    };
    Bool.prototype.and = function (that) {
        return that;
    };
    Bool.prototype.not = function () {
        return this._value ? Value.False : Value.True;
    };
    Bool.prototype.stringValue = function () {
        return this._value ? 'true' : 'false';
    };
    Bool.prototype.booleanValue = function () {
        return this._value;
    };
    Bool.prototype.toAny = function () {
        return this._value;
    };
    Bool.prototype.valueOf = function () {
        return this._value;
    };
    Bool.prototype.writeRecon = function (output) {
        if (this._value) {
            output.push(116, 114, 117, 101);
        }
        else {
            output.push(102, 97, 108, 115, 101);
        }
    };
    Bool.prototype.toRecon = function () {
        return this._value ? 'true' : 'false';
    };
    Bool.prototype.toReconBlock = function () {
        return this._value ? 'true' : 'false';
    };
    Bool.prototype.compare = function (that) {
        if (that instanceof Bool) {
            if (this._value && !that._value) {
                return -1;
            }
            else if (!this._value && that._value) {
                return 1;
            }
            else {
                return 0;
            }
        }
        else if (that instanceof Item.Field || that instanceof Item.Record
            || that instanceof Item.Data || that instanceof Item.Text
            || that instanceof Item.Num) {
            return 1;
        }
        else {
            return -1;
        }
    };
    Bool.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof Bool) {
            return this._value === that._value;
        }
        return false;
    };
    Bool.prototype.hashCode = function () {
        return this._value ? 0x47DB14C7 : 0x9FE4B312;
    };
    Bool.prototype.toString = function () {
        return this.toRecon();
    };
    Bool.valueOf = function (value) {
        return value ? Bool.True : Bool.False;
    };
    Bool.of = function (value) {
        if (value instanceof Bool) {
            return value;
        }
        else if (typeof value === 'boolean') {
            return Bool.valueOf(value);
        }
        else {
            throw new TypeError('' + value);
        }
    };
    Bool.True = new Bool(true);
    Bool.False = new Bool(false);
    return Bool;
}(Value));
export { Bool };
Item.Bool = Bool;
Item.True = Bool.True;
Item.False = Bool.False;
Value.True = Bool.True;
Value.False = Bool.False;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9vbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImJvb2wudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxJQUFJLEVBQUMsTUFBTSxRQUFRLENBQUM7QUFDNUIsT0FBTyxFQUFXLEtBQUssRUFBQyxNQUFNLFNBQVMsQ0FBQztBQUt4QztJQUEwQixnQ0FBSztJQUk3QixjQUFvQixLQUFjO1FBQWxDLFlBQ0UsaUJBQU8sU0FFUjtRQURDLEtBQUksQ0FBQyxNQUFNLEdBQUcsS0FBSyxDQUFDOztJQUN0QixDQUFDO0lBRUQsc0JBQUksdUJBQUs7YUFBVDtZQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO1FBQ3JCLENBQUM7OztPQUFBO0lBSUQsaUJBQUUsR0FBRixVQUFHLElBQVU7UUFDWCxNQUFNLENBQUMsSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUlELGtCQUFHLEdBQUgsVUFBSSxJQUFVO1FBQ1osTUFBTSxDQUFDLElBQUksQ0FBQztJQUNkLENBQUM7SUFFRCxrQkFBRyxHQUFIO1FBQ0UsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUM7SUFDaEQsQ0FBQztJQUVELDBCQUFXLEdBQVg7UUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUM7SUFDeEMsQ0FBQztJQUVELDJCQUFZLEdBQVo7UUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztJQUNyQixDQUFDO0lBRUQsb0JBQUssR0FBTDtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO0lBQ3JCLENBQUM7SUFFRCxzQkFBTyxHQUFQO1FBQ0UsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUM7SUFDckIsQ0FBQztJQUVELHlCQUFVLEdBQVYsVUFBVyxNQUFtQjtRQUM1QixFQUFFLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztZQUNoQixNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBUyxHQUFHLEVBQVMsR0FBRyxFQUFTLEdBQUcsQ0FBUSxDQUFDO1FBQzlELENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFTLEVBQUUsRUFBUyxHQUFHLEVBQVMsR0FBRyxFQUFTLEdBQUcsQ0FBUSxDQUFDO1FBQ3pFLENBQUM7SUFDSCxDQUFDO0lBRUQsc0JBQU8sR0FBUDtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQztJQUN4QyxDQUFDO0lBRUQsMkJBQVksR0FBWjtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQztJQUN4QyxDQUFDO0lBRUQsc0JBQU8sR0FBUCxVQUFRLElBQVU7UUFDaEIsRUFBRSxDQUFDLENBQUMsSUFBSSxZQUFZLElBQUksQ0FBQyxDQUFDLENBQUM7WUFDekIsRUFBRSxDQUFDLENBQUMsSUFBSSxDQUFDLE1BQU0sSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO2dCQUNoQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDWixDQUFDO1lBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLE1BQU0sSUFBSSxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztnQkFDdkMsTUFBTSxDQUFDLENBQUMsQ0FBQztZQUNYLENBQUM7WUFBQyxJQUFJLENBQUMsQ0FBQztnQkFDTixNQUFNLENBQUMsQ0FBQyxDQUFDO1lBQ1gsQ0FBQztRQUNILENBQUM7UUFBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMsSUFBSSxZQUFZLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxZQUFZLElBQUksQ0FBQyxNQUFNO2VBQ3pELElBQUksWUFBWSxJQUFJLENBQUMsSUFBSSxJQUFJLElBQUksWUFBWSxJQUFJLENBQUMsSUFBSTtlQUN0RCxJQUFJLFlBQVksSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7WUFDcEMsTUFBTSxDQUFDLENBQUMsQ0FBQztRQUNYLENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUNaLENBQUM7SUFDSCxDQUFDO0lBRUQscUJBQU0sR0FBTixVQUFPLElBQVM7UUFDZCxFQUFFLENBQUMsQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLENBQUMsQ0FBQztZQUNsQixNQUFNLENBQUMsSUFBSSxDQUFDO1FBQ2QsQ0FBQztRQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxJQUFJLFlBQVksSUFBSSxDQUFDLENBQUMsQ0FBQztZQUNoQyxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sS0FBSyxJQUFJLENBQUMsTUFBTSxDQUFDO1FBQ3JDLENBQUM7UUFDRCxNQUFNLENBQUMsS0FBSyxDQUFDO0lBQ2YsQ0FBQztJQUVELHVCQUFRLEdBQVI7UUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUM7SUFDL0MsQ0FBQztJQUVELHVCQUFRLEdBQVI7UUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU8sRUFBRSxDQUFDO0lBQ3hCLENBQUM7SUFNTSxZQUFPLEdBQWQsVUFBZSxLQUFjO1FBQzNCLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7SUFDeEMsQ0FBQztJQUVNLE9BQUUsR0FBVCxVQUFVLEtBQWU7UUFDdkIsRUFBRSxDQUFDLENBQUMsS0FBSyxZQUFZLElBQUksQ0FBQyxDQUFDLENBQUM7WUFDMUIsTUFBTSxDQUFDLEtBQUssQ0FBQztRQUNmLENBQUM7UUFBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMsT0FBTyxLQUFLLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQztZQUN0QyxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUM3QixDQUFDO1FBQUMsSUFBSSxDQUFDLENBQUM7WUFDTixNQUFNLElBQUksU0FBUyxDQUFDLEVBQUUsR0FBRyxLQUFLLENBQUMsQ0FBQztRQUNsQyxDQUFDO0lBQ0gsQ0FBQztJQWhCZSxTQUFJLEdBQUcsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFFdEIsVUFBSyxHQUFHLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBZTFDLFdBQUM7Q0FBQSxBQWpIRCxDQUEwQixLQUFLLEdBaUg5QjtTQWpIWSxJQUFJO0FBa0hoQixJQUFZLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztBQUN6QixJQUFZLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUM7QUFDOUIsSUFBWSxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDO0FBQ2hDLEtBQWEsQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQztBQUMvQixLQUFhLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMifQ==